import { EventSourceHandler } from '@sellsy/sse';

export default class BRTransferTransactionsCompletedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.transaction.transfer.completed';
    }

    handle(event) {
        EventBus.emit('transaction:transfer:completed', event);
    }
}
